// extracted by mini-css-extract-plugin
export default {"tag":"PrimaryTag_tag__x-Muj"};